import { render, staticRenderFns } from "./comments-sidebar.vue?vue&type=template&id=02818f9e&"
import script from "./comments-sidebar.vue?vue&type=script&lang=js&"
export * from "./comments-sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports